<template>
  <div class="mt-6">
    <div class="w-full text-right sm:w-auto">
      <button type="button" class="w-full btn-primary sm:w-auto">
        {{ cta }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    cta: String,
  },
};
</script>
